import { ApsBranding } from 'UserExperience/portal-vnext';

const BrandingAPI = ({ brandSettings }) => {

  return (
    <ApsBranding
      logoMaxHeightSmallDevices = {brandSettings.logoMaxHeightSmallDevices}
      logoMaxHeightLargeDevices = {brandSettings.logoMaxHeightLargeDevices}
      colorBrandA = {brandSettings.colorBrandColorA}
      colorBrandAMuted = {brandSettings.colorBrandColorMuted}
      colorBrandB = {brandSettings.colorBrandColorB}
      colorGradientA = {brandSettings.colorGradientA}
      colorGradientB = {brandSettings.colorGradientB}
      colorUtilityLink = {brandSettings.colorLinkDefault}
      colorUtilityStateSuccess = {brandSettings.colorStateSuccess}
      colorUtilityStateError = {brandSettings.colorStateError}
      colorTypeA = {brandSettings.colorTextA}
      colorTypeB = {brandSettings.colorTextB}
      colorStructureMain = {brandSettings.colorStructureMain}
      colorStructureLighter = {brandSettings.colorStructureLighter}
      colorStructureBorder = {brandSettings.colorStructureBorder}
      colorStructureBackground = {brandSettings.colorStructureBackground}
    />
  );
};

export default BrandingAPI;